import { SET_MENU, CLEAR_MENU, TOAST_MESSAGES_PUSH } from './mutation-types';
import { ApiService as api } from '@/services/axiosHelper';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'menu',
	namespaced: true,
	state: {
		menu: []
	},
	mutations: {
		[SET_MENU](state, menu) {
			state.menu = menu;
		},
		[CLEAR_MENU](state) {
			state.menu = [];
		}
	},
	actions: {
		async loadMenu({ commit, dispatch }) {
			commit(CLEAR_MENU);
			return new Promise((resolve, reject) => {
				api.get('/menu')
					.then(resp => {
						commit(SET_MENU, resp.menuItems);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		}
	}
};
